import type { UserRole } from "@/APIClient";
import { MenuType, type MenuEntity } from "@/components/UI/menu/menu.types";

export enum PagesIndex {
  PROJECTS = "projects",
  HOME = "home",
  ARCHIVES = "archives",
  SYNC_ISSUES = "synchronization-issues",
  LEGENDS = "legends",
  PART_TEMPLATES = "part-templates",
  ORGANIZATION_SETTINGS = "organization-settings",
  MEMBERS = "members",
  REPORT_TEMPLATES = "templates",
  SETTINGS = "settings",
}

const roleAuthorizations: Record<PagesIndex, UserRole[] | null> = {
  [PagesIndex.HOME]: null,
  [PagesIndex.PROJECTS]: null,
  [PagesIndex.ARCHIVES]: null,
  [PagesIndex.SYNC_ISSUES]: null,
  [PagesIndex.REPORT_TEMPLATES]: null,
  [PagesIndex.MEMBERS]: ["ADMIN", "SUPERADMIN"],
  [PagesIndex.LEGENDS]: ["ADMIN", "SUPERADMIN", "MANAGER"],
  [PagesIndex.PART_TEMPLATES]: null,
  [PagesIndex.ORGANIZATION_SETTINGS]: ["ADMIN", "SUPERADMIN", "MANAGER"],
  [PagesIndex.SETTINGS]: null,
};

export function filterMenuByRole(
  role: UserRole,
  menuToFilter: MenuEntity[]
): MenuEntity[] {
  function filterMenu(menu: MenuEntity[]): MenuEntity[] {
    return menu.reduce((acc: MenuEntity[], item) => {
      const authorization = roleAuthorizations[item.index as PagesIndex];
      // If index not in roleAuthorizations (undefined), allow access
      const isAuthorized =
        authorization === undefined ||
        authorization === null ||
        authorization.includes(role);

      if (item.type === MenuType.GROUP) {
        const children = filterMenu(item.children || []);
        if (children.length > 0) {
          acc.push({ ...item, children });
        }
      } else if (isAuthorized) {
        acc.push(item);
      }

      return acc;
    }, []);
  }
  return filterMenu(menuToFilter);
}
